import {SET_SPREADS} from '../actions/types';


const spreads = (state = null, action) => {
  switch (action.type) {
    case SET_SPREADS:
      return action.payload;
    default:
      return state;
  }
};

export default spreads;